// /// SWPIER              ////////
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
//about swiper

export function aboutSwiperFunc() {
  const main = document.querySelector('.hero_swiper');
  main.classList.add('loaded');

  const slideLength = document.querySelectorAll(
    '.hero_swiper .swiper-slide'
  ).length;
  const swiper = new Swiper('.hero_swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    // allowTouchMove: false,
    loopedSlides: slideLength,
    speed: 4500,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
    grabCursor: true,

    breakpoints: {
      // 768px以上の場合
      768: {
        slidesPerView: 3,
      },
    },
    on: {
      touchEnd: (swiper) => {
        swiper.slideTo(swiper.activeIndex + 1);
      },
    },
  });
}
